/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Team } from './Team';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
    TeamToJSONTyped,
} from './Team';
import type { PagingOutput } from './PagingOutput';
import {
    PagingOutputFromJSON,
    PagingOutputFromJSONTyped,
    PagingOutputToJSON,
    PagingOutputToJSONTyped,
} from './PagingOutput';

/**
 * 
 * @export
 * @interface ListTeamsOutputBody
 */
export interface ListTeamsOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ListTeamsOutputBody
     */
    readonly $schema?: string;
    /**
     * Paging Output
     * @type {PagingOutput}
     * @memberof ListTeamsOutputBody
     */
    pagingOutput: PagingOutput;
    /**
     * Teams
     * @type {Array<Team>}
     * @memberof ListTeamsOutputBody
     */
    teams: Array<Team> | null;
}

/**
 * Check if a given object implements the ListTeamsOutputBody interface.
 */
export function instanceOfListTeamsOutputBody(value: object): value is ListTeamsOutputBody {
    if (!('pagingOutput' in value) || value['pagingOutput'] === undefined) return false;
    if (!('teams' in value) || value['teams'] === undefined) return false;
    return true;
}

export function ListTeamsOutputBodyFromJSON(json: any): ListTeamsOutputBody {
    return ListTeamsOutputBodyFromJSONTyped(json, false);
}

export function ListTeamsOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTeamsOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'pagingOutput': PagingOutputFromJSON(json['paging_output']),
        'teams': (json['teams'] == null ? null : (json['teams'] as Array<any>).map(TeamFromJSON)),
    };
}

export function ListTeamsOutputBodyToJSON(json: any): ListTeamsOutputBody {
    return ListTeamsOutputBodyToJSONTyped(json, false);
}

export function ListTeamsOutputBodyToJSONTyped(value?: Omit<ListTeamsOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paging_output': PagingOutputToJSON(value['pagingOutput']),
        'teams': (value['teams'] == null ? null : (value['teams'] as Array<any>).map(TeamToJSON)),
    };
}

